import { gql, installApollo, mutate, watchQuery } from 'codefabrik-gui-vue/src/apollo'
import router from '../router'
import { getToken, logout } from '@/keycloak'

const logoutStatusCodes = [400, 401, 403, 405]

const handleNetworkError = logout

const graphQlErrorHandler = new function () {
  this.handle = function () {}
}()

function setGraphQlErrorHandler (errorFn) {
  graphQlErrorHandler.handle = errorFn
}

const beforeRequest = async operation => {
  operation.setContext({ headers: { 'Authorization': 'Bearer ' + await getToken() } })
}

const onError = error => {
  if (error.networkError) {
    if (logoutStatusCodes.indexOf(error.networkError.statusCode) !== -1) {
      handleNetworkError()
    } else {
      router.push({ name: 'network-error', query: {
          from: router.currentRoute.query.from || router.currentRoute.fullPath
        }})
    }
  } else if (error.graphQLErrors) {
    graphQlErrorHandler.handle(error.graphQLErrors[0])
  }
}

const apollo = installApollo({
  httpLinkConfig: { uri: '/graphql', credentials: 'include' },
  beforeRequest: beforeRequest,
  onError: onError
})

const query = apollo.query

export default apollo
export { setGraphQlErrorHandler, gql, watchQuery, mutate, query }
